<div class="standalone-list">
  @if (loading) {
    <div class="standalone-list__loading">
      <pdq-spinner></pdq-spinner>
    </div>
  } @else if (rows.length === 0) {
    <div class="empty-state">
      <h3 class="empty-state__title">No standalone widgets yet</h3>
      <p class="empty-state__subtitle">
        Standalone widgets embed a single widget — like Order Protection — directly into your store.
      </p>
      <pdq-button variant="secondary" (onClick)="onNew()">+ New Widget</pdq-button>
    </div>
  } @else {
    <pdq-card color="white" variant="popover">
      @for (row of rows; track row.widget.id) {
        <div class="list-row">
          <div class="list-row__info">
            <div class="list-row__title">{{ row.widget.name || 'Untitled' }}</div>
            <span class="list-row__subtitle">{{ row.subtitle }}</span>
          </div>

          <div class="list-row__actions">
            @if (row.widget.id === duplicatingId) {
              <pdq-spinner [small]="true"></pdq-spinner>
            } @else {
              <feature-mode-picker
                tagSize="small"
                tagMode="rect"
                [hideTestMode]="true"
                [control]="row.stateControl"></feature-mode-picker>
              <pdq-button
                pdqPopover
                variant="ghost"
                icon="dots_menu"
                [popoverTemplate]="actions"
                [forcePosition]="'bottom'"
                [closeOnPopoverClick]="true"
                [closeOnClickOutside]="true">
              </pdq-button>
              <ng-template #actions>
                <pdq-popover-container [loading]="false" [actionList]="true">
                  <div class="action-list">
                    @for (option of actionOptions; track option.value) {
                      @if (option.value === Actions.DELETE && row.widget.isLive) {
                        <pdq-option [disabled]="true">
                          <div class="action-list__delete-disabled">
                            <span>{{ option.label }}</span>
                            <span class="action-list__delete-disabled-hint">Must be disabled to delete</span>
                          </div>
                        </pdq-option>
                      } @else {
                        <pdq-option (onSelect)="onActionOptionSelect(option.value, row.widget.id)">
                          {{ option.label }}
                        </pdq-option>
                      }
                    }
                  </div>
                </pdq-popover-container>
              </ng-template>
            }
          </div>
        </div>

        <pdq-divider></pdq-divider>
      }

      <button type="button" class="standalone-list__add" (click)="onNew()">Add more standalone widgets</button>
    </pdq-card>
  }
</div>
